/**
 * API 列表
 */

 //检查环境设置、开发工具、环境、页面调试
const SERVER = {

  APPID: 'h5', //配置APPID
  API_DEV: false, // API环境设置
  DEV: false, // 登录环境设置
  CONSOLE: false,//是否显示console

  //API
  // URL_TEST: "http://192.168.1.156:8082/", //测试
  URL_TEST: "https://devapi-nowbook.runderful.cn/", //测试
  URL_PRODUCT: "https://zhishu.runderful.cn/", //正式环境
  URL: "",
  // URL: "https://devapi.nowbook.sup.services/", //灰度
  //URL: "https://zhishu.v5.idcfengye.com/", //H5
  //URL: "http://zhishu.v4.idcfengye.com/", //测试H5

  //阅读器
  // READER_URL_TEST: 'http://192.168.1.127:8081/reader.html#',
  READER_URL_TEST: 'https://test-zhishu.runderful.cn/h5/v/reader.html#',
  READER_URL_PRODUCT: 'https://zhishu.runderful.cn/h5/v/reader.html#',
  READER_URL: "",

  //项目部署地址
  // HOST_PAGE_TEST: 'http://192.168.1.127:8080/index.html#',
  HOST_PAGE_TEST: 'https://test-zhishu.runderful.cn/h5/v/index.html#',
  HOST_PAGE_PRODUCT: 'https://zhishu.runderful.cn/h5/v/index.html#',
  HOST_PAGE_URL: "",

  //支付
  PAYDOLLAR_TEST: 'https://test.paydollar.com/b2cDemo/eng/payment/payForm.jsp',
  PAYDOLLAR_PRODUCT: 'https://www.paydollar.com/b2c2/eng/payment/payForm.jsp',
  PAYDOLLAR_URL: "",

  //支付商户号
  PAYDOLLAR_TEST_METCHANT_ID : '88162072',
  PAYDOLLAR_PRODUCT_METCHANT_ID: '88636131',
  PAYDOLLAR_METCHANT_ID: "",

}

function initEnv(){
  SERVER.URL =  SERVER.API_DEV?SERVER.URL_TEST:SERVER.URL_PRODUCT;
  SERVER.HOST_PAGE_URL = SERVER.API_DEV?SERVER.HOST_PAGE_TEST:SERVER.HOST_PAGE_PRODUCT;
  SERVER.PAYDOLLAR_URL = SERVER.API_DEV?SERVER.PAYDOLLAR_TEST:SERVER.PAYDOLLAR_PRODUCT;
  SERVER.PAYDOLLAR_METCHANT_ID = SERVER.API_DEV?SERVER.PAYDOLLAR_TEST_METCHANT_ID:SERVER.PAYDOLLAR_PRODUCT_METCHANT_ID;
  SERVER.READER_URL =  SERVER.API_DEV?SERVER.READER_URL_TEST:SERVER.READER_URL_PRODUCT;
}

initEnv()

const CONFIG = {
  //获取图片签名
  GETUPLOADTOKEN: "api/media/aliyun/uploadToken?expireMinute=30",

  //获取积分比例和单位
  RATECONFIG: 'h5/media/index/rateConfig',

  //區塊接口
  BLOCK: {
    GETPAGECODE: "h5/media/data/getMainPage" ,//H5首页區塊内容
    GETLIST: "h5/media/data/selectProjectPageItems" ,//H5更多列表
  },

  //多媒體文件接口
  MEDIA: {
    //GET: "api/media/data/get",
    //GET: "rpc/app/project/getBookInfo", //h5
    COLUMN: "h5/media/data/albumInfo", //h5 專輯
    GET: "h5/media/data/get", //h5 內容詳情
    GETBLOCKBYCODE: "api/media/cms/getBlocklistByCode",
  },

  // 专栏接口
  COLUMN: {
    GETTREE: "h5/media/data/getTreeByCode" ,//H5分类树
    CLASSSEARCH: "h5/media/data/query", //h5分类内容

    GET: "api/media/list/get", // 获取专栏
    GETHOTKEYWORDS: "api/media/list/getHotKeywords", // 获取热门关键词
    QUERY: "api/media/list/query", // 查询
    //SEARCHBYKEYWORD: "api/media/list/searchByKeyword", // 搜索
    SEARCHBYKEYWORD: "h5/media/data/searchByKeyword", // 搜索
    SEARCHMOREBYKEYWORD: "h5/media/data/searchMoreByKeyword",// 根据栏目code搜索更多

    SEARCHBYTAG: "api/media/list/searchByTag",// 根据标签搜索
    SEARCHMOREBYTAG: "api/media/list/searchMoreByTag",// 根据标签搜索更多

  },

  USER: {
    TELLOGIN: "h5/user/loginTel", //手機號註冊登錄
    TELVERIFICATIONCODE: "h5/user/getTelVerificationCode", //發送手機驗證碼
    REGISTER: "h5/user/register", //郵箱註冊
    EMAILVERIFICATIONCODE: "h5/user/getVerificationCode", //發送郵箱驗證碼
    LOGIN: "h5/user/login", //登錄
    GETUSERINFO: "h5/user/getUserInfo", //獲取用戶信息
    CHANGEEMAIL: "h5/user/changeEmail", //更換郵箱
    BINDEMAIL: "h5/user/bindEmail", //綁定郵箱
    BINDPHONE: "h5/user/bindPhone", //綁定手機
    LOGOUT: "h5/user/logout", //退出登錄
    UPDATEINFO: "h5/user/updateInfo", //更新用戶信息
    //WECHATLOGIN: "api/user/wechatLogin", //微信登錄
    FORGETPASSWORD: "h5/user/forgetPassword", //重置密碼
    FORGETCODE: "h5/user/forgetCode", //忘記密碼獲取郵箱驗證碼
    THIRDLOGIN: 'h5/user/thirdLogin', //mylink登录
    GETCOINACCOUNTINFO: "api/media/coin/account",
    //REFRESHSESSION: 'h5/user/getUserSession/' ,//检验session是否登录
    REFRESHSESSION: 'h5/user/refreshSession' ,//更新session
  },

  ORDER: {
    BUY: "h5/media/order/buy",
    BUYLIST: "h5/media/buyLog/queryBuyList",
    //BUYLIST: "api/media/order/queryBuyList"
  },

  H5BUY: {
    BUY: "h5/media/buy",
    PAY: 'h5/media/pay',
    CANCEL: 'h5/media/cancel',
    GET_BUY_OBJECT: "h5/media/getBuyingObject", //购买页详情, 返回商品信息/账户余额/优惠券列表等
  },

  // 合并请求
  MERGEREQUEST: 'api/media/index/mergeRequest',

  FILE: {
    //GETAUTHURL: "", //获取文件授权访问地址
    GETPLAYURL: "h5/media/data/getPlayUrl"//获取文件授权访问地址
  },


  //知書幣相關接口
  COIN: {
    //CONFIG: "api/media/coin/config", //充值知書幣配置
    BUYCOIN: "api/media/coin/buy", //充值購買知書幣
    ACCOUNT: 'api/media/coin/account', //查询余额
    PAYCOIN: 'api/media/coin/pay'
  },

 //优惠券接口
 COUPON: {
  GET_ME_COUPON: "api/coupon/query", //我的优惠券
  EXCHANGE_COUPON: "api/coupon/exchange", //兑换码兑换优惠券
  GET_COUPON: "api/coupon/get", //获取指定优惠券详情
  GET_BUY_OBJECT: "api/media/order/getBuyingObject", //购买页详情, 返回商品信息/账户余额/优惠券列表等
  EXCHANGE_GOODS: "api/media/order/exchange", //    使用优惠券兑换礼品
  BY_SUCCESS_COUPON: "api/activity/share/getIsShare", // 获取用户支付成功之后是否能参加活动
  RECEIVE_COUPON: "api/activity/share/receive", //購買成功領取優惠券
  USEOFFLINE: "api/coupon/useOffline", //綫下使用
  COUPON_INFO: "api/coupon/template/getCouponTemplateInfo", //根据加密模板id获取模板信息
  GET_QR_COUPON: "api/coupon/giveCouponByQRCode", //扫描二维码下发优惠券
  IS_BUY: "api/media/order/isBuy", //判断内容和专辑是否已购买
  GET_COUPON_TOPIC_LIST: "api/coupon/detailList" //主题卡优惠券详情列表
},

  NOWBOOK: {
    SHARE_VIDEO_URL: "/nowbook/media/share/video/url/",
    SHARE_EPUB_TRIAL_READ: "/nowbook/media/share/epub/trial/read/",
    SHARE_EPUB_TRIAL_PREPARE: "/nowbook/media/share/epub/trial/prepare/"
  },

  //评论接口
  COMMENT: {

    // 添加评论
    ADD: "api/comment/add",

    // 取消点赞
    CANCELLIKE: "api/comment/cancelLike",

    // 获取置顶评论
    GETTOP: "api/comment/getTop",

    // 点赞
    LIKE: "api/comment/like",

    // 查询评论列表
    QUERY: "api/comment/query",

  },

  //用戶操作記錄接口
  OPERATE: {
    ADD: "api/media/operate/add",
    CANCEL: 'api/media/operate/cancel',
    QUERY: 'api/media/operate/query'
  },

  BOOK: {
    //相关书籍推荐
    RELBOOK: "api/book/rel/get"
  },

  USER111: {
    TELLOGIN: "api/user/loginTel", //手機號註冊登錄
    TELVERIFICATIONCODE: "api/user/getTelVerificationCode", //發送手機驗證碼
    REGISTER: "api/user/register", //郵箱註冊
    EMAILVERIFICATIONCODE: "api/user/getVerificationCode", //發送郵箱驗證碼
    LOGIN: "api/user/login", //登錄
    GETUSERINFO: "api/user/getUserInfo", //獲取用戶信息
    CHANGEEMAIL: "api/user/changeEmail", //更換郵箱
    BINDEMAIL: "api/user/bindEmail", //綁定郵箱
    BINDPHONE: "api/user/bindPhone", //綁定手機
    LOGOUT: "api/user/logout", //退出登錄
    UPDATEINFO: "api/user/updateInfo", //更新用戶信息
    WECHATLOGIN: "api/user/wechatLogin", //微信登錄
    FORGETPASSWORD: "api/user/forgetPassword", //忘記密碼
    THIRDLOGIN: 'api/user/thirdLogin', //第三方登录
    GETCOINACCOUNTINFO: "api/media/coin/account",

  },

  epub: {
    getToken: "api/media/data/getEpubToken",
    token: "api/media/epub/token",
    addBookMark: "api/media/epub/bookmark/save",
    getBookMark: "api/media/epub/bookmark/query",
    deleteBookMark: "api/media/epub/bookmark/delete",
    noteSave: "api/media/epub/note/save", //保存笔记
    noteQuery: "api/media/epub/note/query", //查询笔记
    noteDelete: "api/media/epub/note/delete", //物理删除笔记
    noteParagraph: 'api/media/epub/note/queryByParagraph', //获取包含公共笔记
    downEpub: 'api/media/epub/prepareDownload', //电子书下载
    CHECKEPUBFREE: 'api/media/order/isFreeForRead', //檢查下載的電子書是否免費
  },

  pdf:{
    getPdfSecret: "api/media/pdf/read",//获取pdf阅读资源
    token: "api/media/pdf/token",//获取加载pdf的token
    loadPdfImage:"api/media/pdf/loadImg",
  },

}


module.exports = {
  CONFIG,
  SERVER,
  initEnv
}



// WEBPACK FOOTER //
// ./src/api/apiConfig.js